class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerOverlay = this.querySelector('[data-cart-drawer-overlay]');
    this.cartLink = document.querySelector('[data-cart-link]');

    if (this.cartLink) {
      this.cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(this.cartLink);
      });
    }

    this.addEventListener('click', (event) => {
      if (!event.target.hasAttribute('data-cart-drawer-close')) { return; }
      this.close();
    });

    this.cartDrawerOverlay.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector('[data-cart-drawer-note] summary');

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.classList.add('active');
    window.trapFocus(this);

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('[data-cart-drawer-inner-empty]') : document.querySelector('[data-cart-drawer]');
      const focusElement = this.querySelector('[data-cart-drawer-inner]') || this.querySelector('.cart-drawer__close');
      window.trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    if (window.innerWidth >= 1025) {
      document.body.classList.add('overflow-hidden');
    } else {
      window.scrollLock();
    }
  }

  close() {
    this.classList.remove('active');
    window.removeTrapFocus(this.activeElement);

    if (window.innerWidth >= 1025) {
      document.body.classList.remove('overflow-hidden');
    } else {
      window.removeScrollLock();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  }

  renderContents(parsedState) {
    this.querySelector('[data-cart-drawer-inner]').classList.contains('is-empty') && this.querySelector('[data-cart-drawer-inner]').classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    const cartCountIcon = document.querySelector('[data-cart-count-icon]');
    const cartCountValue = document.querySelector('[data-cart-count-value]');

    if (cartCountIcon && cartCountValue) {
      cartCountValue.innerHTML = cartCountValue.innerHTML.replace('(', '').replace(')', '');
    }

    const cartCountBadge = document.querySelector('[data-cart-count-badge]');

    if (cartCountBadge) {
      cartCountBadge.classList.add('active');
    }

    setTimeout(() => {
      this.querySelector('[data-cart-drawer-overlay]').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '[data-cart-drawer]'
      },
      {
        id: 'cart-count'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartPage {
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '[data-cart-drawer-inner]'
      },
      {
        id: 'cart-count',
        section: 'cart-count',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
